/*
 * In-app browsers (the Google app, Chrome on iOS) and some extensions inject
 * scripts straight into the page. Their errors arrive with every stack frame
 * pointing at the HTML document itself, at line numbers past the end of the
 * page. Nothing of ours runs from the document: every frame of our code lives
 * in a .js chunk. Sentry's denyUrls cannot express "the page's own URL", so an
 * event processor does it.
 *
 * Known cost: the inline bootstrap scripts in src/html.js also run from the
 * document, so an error thrown there would be dropped too.
 */
const SCRIPT_FILE = /\.m?js(?:[?#]|$)/i;
const HTTP_URL = /^https?:\/\//i;

const isDocumentFrame = (frame) => (
  !!frame
  && typeof frame.filename === 'string'
  && HTTP_URL.test(frame.filename)
  && !SCRIPT_FILE.test(frame.filename)
);

export const isInjectedScriptEvent = (event) => {
  const values = (event && event.exception && event.exception.values) || [];
  const frames = values.reduce((all, value) => (
    all.concat((value && value.stacktrace && value.stacktrace.frames) || [])
  ), []);
  return frames.length > 0 && frames.every(isDocumentFrame);
};

export const dropInjectedScriptEvents = (event) => (isInjectedScriptEvent(event) ? null : event);
